import React from 'react';
import { AfterSubmitFunc, Dropdown, FormTemplate, TextInput } from 'ui-builder';
import { BaseTaskGroupRequest, TasksGroup, TasksGroupPermission } from 'nekst-api';
import { ColorPicker } from 'features/nekst-widgets';

function HiddenStatusDropdown(props: {
  source: string,
  label: string
}) {
  return (
    <Dropdown
      options={[
        {
          value: false,
          label: 'Show',
        },
        {
          value: true,
          label: 'Hide',
        },
      ]}
      source={props.source}
      label={props.label}
    />
  );
}

export default function BaseTasksGroupForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
    title?: string,
    submitFormFunc: (data: BaseTaskGroupRequest) => Promise<TasksGroup>,
    initialData?: TasksGroup,
  }
) {

  const showHiddenStatusDropdown = !!(props.initialData?.id && !props.initialData._permissions.includes(TasksGroupPermission.DELETE));

  return (
    <FormTemplate<BaseTaskGroupRequest, TasksGroup>
      submitFormFunc={async (data) => {
        return await props.submitFormFunc(data);
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      title={props.title}
      initialData={props.initialData || {
        color: '#000000'
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
          }
        },
        color: {
          type: 'string',
          constraints: {
            required: true,
            minLength: {
              value: 7,
              message: 'Color must be a hex color code'
            },
            maxLength: {
              value: 7,
              message: 'Color must be a hex color code'
            }
          }
        }
      }}
    >
      <TextInput source="name" label="Group Name" isDisabled={showHiddenStatusDropdown} />
      <ColorPicker source="color" label="Color" />
      {showHiddenStatusDropdown && <HiddenStatusDropdown source="isHidden" label="Visibility" />}
    </FormTemplate>
  );
}
